import { ShipVisit } from '@/routes/(app)/(scenarios)/(create)/types';

export const getTransferEligibleVisits = (
  visits: Array<ShipVisit>,
  startTime: string
): Array<ShipVisit> => {
  const start = new Date(startTime).getTime();
  return visits.filter((visit) => {
    if (visit.historic) return false;
    const end =
      visit.end_work_time ?? visit.departure_time ?? visit.arrival_time;
    return new Date(end).getTime() >= start;
  });
};

export const excludeShipOfVisit = (
  visits: Array<ShipVisit>,
  visitId: string
): Array<ShipVisit> => {
  const shipId = visits.find((visit) => visit.id === visitId)?.ship_id;
  if (!shipId) return visits;
  return visits.filter((visit) => visit.ship_id !== shipId);
};
